module.exports = __webpack_public_path__ + "static/media/closeIconGrey.736bf2f2.svg";